import React, { useState } from "react";
import { useObserver } from "mobx-react";
import styles from "./styles.module.scss";
import { useParams } from "react-router";
import { Button, CircularProgress, Snackbar } from "@material-ui/core";
import { stores } from "mobx-store";
import { translate } from "helperFunctions/translation";
import docTemplates from '../../assets/templates';

const RestaurantMenuBulkUpload: React.FC = () => {

  const {
    id: restaurantId,
  } = useParams<{ id: string }>();

  const {
    restaurantStore,
  } = stores;

  const [menuLoading, setMenuLoading] = useState(false);
  const [imagesLoading, setImagesLoading] = useState(false);
  const [syncLoading, setSyncLoading] = useState(false);
  const [msg, setMsg] = useState('');

  const handleXlsxMenuChange = async (event: any) => {
    try {
      setMenuLoading(true);
      const menuXlsx = event?.target.files[0];
      await restaurantStore.uploadMenusXlsx(+restaurantId, menuXlsx);
      setMsg(translate('savedMessage'));
    } catch(error) {
      setMsg(error || translate("errorMessage"));
    } finally {
      setMenuLoading(false);
    }
  };

  const handleCompressedImagesChange = async (event: any) => {
    try {
      setImagesLoading(true);
      const compressedImages: File = event?.target.files[0];

      if (compressedImages?.type === 'application/x-zip-compressed' && compressedImages?.name.endsWith('.zip')) {
        await restaurantStore.uploadMenuImages(+restaurantId, compressedImages);
        setMsg(translate('savedMessage'));
      } else {
        setMsg(translate('invalidFileType'));
      }
    } catch (error) {
      setMsg(error.message || translate('errorMessage'));
    } finally {
      setImagesLoading(false);
    }
  };
  const syncButtonClicked = async () => {
    try {
      setSyncLoading(true);
      await restaurantStore.restaurantImagesSync();
      setMsg(translate('savedMessage'));
    } catch(error) {
      setMsg(error || translate("errorMessage"));
    } finally {
      setSyncLoading(false);
    }
  };

  const UploadCsv = () => (
    <div className={styles.uploadcard}>
      <h3>Upload xlsx file with restaurant meals data</h3>
      <input
        accept=".xlsx, .xls, .csv"
        style={{ display: 'none' }}
        id="raised-button-menu"
        multiple
        type="file"
        onChange={handleXlsxMenuChange}
      />
      {
        !menuLoading
          ? (
            <label htmlFor="raised-button-menu">
              <Button color="primary" variant="contained" component="span">
                Upload
              </Button>
            </label>
          )
          : <CircularProgress size="1.2rem" color="inherit" />
      }
      <div className={styles.downloadBtn}>
        <Button
          color="primary"
          variant="contained"
          component="a"
          href={docTemplates.restaurantMenuXlsx}
          download="restaurant-menu-template.xlsx"
        >
          Download Template
        </Button>
      </div>
    </div>
  );

  const UploadZipImages = () => (
    <div className={styles.uploadcard}>
      <h3>Upload .zip images file</h3>
      <input
        accept=".zip"
        style={{ display: 'none' }}
        id="raised-button-image"
        multiple
        type="file"
        onChange={handleCompressedImagesChange}
      />
      {!imagesLoading ? (
        <label htmlFor="raised-button-image">
          <Button color="primary" variant="contained" component="span">Upload</Button>
        </label>
      ) : (
        <CircularProgress size="1.2rem" color="inherit" />
      )}
    </div>
  );
  const SyncMenuImages = () => (
    <div className={styles.uploadcard}>
    <h3>Sync the xlsx menu with images.zip</h3>
     {
        !syncLoading ? 
        <label htmlFor="raised-button-image">       
            <Button onClick={syncButtonClicked} color="primary" variant="contained" component="span">
              Sync
            </Button>
        </label> :
        <CircularProgress size="1.2rem" color="inherit" /> 
      }
    </div>
  );
  return useObserver(() => (
    <div className={styles.uploadContainer}>
      <UploadCsv />
      <UploadZipImages />
      <SyncMenuImages />
      <Snackbar
          open={!!msg} 
          autoHideDuration={6000}
          onClose={() => setMsg('')}
          message={msg}
      />
    </div>
  ));
};

export default RestaurantMenuBulkUpload;